module.exports = __webpack_public_path__ + "static/about_pic4-40143aa3cfc82cd68364b8bd908c4718.png";